import React from "react";
import cx from "classnames";
import styles from "./RelatedCategories.module.css";
import { useState } from "react";
import { useEffect } from "react";
import { Skeleton } from "@mui/material";
import axios from "axios";
import uuid from "react-uuid";
import { useRouter } from "next/router";

const RelatedCategories = ({ cats }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setLoading(true);
    setError(false);
    axios
      .get(
        "https://about.digikala.com/wp-json/wp/v2/categories?_fields=id,name&lang=fa"
      )
      .then((res) => {
        setError(false);
        if (cats?.length > 0 && res.data?.length > 0) {
          let helperList = [];
          res.data.forEach((item2) => {
            if (cats.includes(item2.id)) {
              helperList.push(item2);
            }
            setLoading(false);
            setCategories(helperList);
          });
        } else {
          setLoading(false);
          // setCategories([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        setCategories([]);
        setError(true);
      });
  }, [cats]);

  const navigateHandler = (id) => {
    router.push({
      pathname: "/newsroom",
      query: {
        cat: `${id}`,
      },
    });
  };
  return (
    <>
      {!error && (
        <>
          <div
            className={cx(
              styles.container,
              "d-flex align-items-center justify-content-start"
            )}
          >
            {loading ? (
              <Skeleton
                className={cx(styles.skeletonStyles, "w-100", "mb-2")}
                variant="rectangular"
                height={50}
              />
            ) : (
              <>
                {categories?.length > 0 && (
                  <div
                    className={cx(
                      styles.catListContainer,
                      "w-100",
                      "d-flex",
                      "flex-column",
                      "align-items-start",
                      "justify-content-center",
                      "flex-wrap",
                      categories.length === 0 && "d-none",
                      "mb-4"
                    )}
                  >
                    {/* <h5>کتگوری‌های مرتبط</h5> */}
                    <div
                      style={{ gap: "10px" }}
                      className="d-flex align-items-start justify-content-start flex-wrap"
                    >
                      {categories?.map((item) => (
                        <button
                          className={cx(
                            styles.catBtnStyles,
                            "d-flex",
                            "align-items-center",
                            "justify-content-center"
                          )}
                          key={uuid()}
                          onClick={() => navigateHandler(item.id)}
                        >
                          {item.name}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default RelatedCategories;
